import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Home from './pages/Home';
import Product from './pages/Product';
import Story from './pages/Story';
import WhySingaraa from './pages/WhySingaraa';
import Contact from './pages/Contact';

// Use basic layout wrappers if any logic is needed, 
// otherwise we can just render the pages which include Header and Footer.

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import FloatingButtons from './components/layout/FloatingButtons';
// import FraudAwarenessPopup from './components/ui/FraudAwarenessPopup';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      {/* <FraudAwarenessPopup /> */}
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product" element={<Product />} />
            <Route path="/story" element={<Story />} />
            <Route path="/why-singaraa" element={<WhySingaraa />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <FloatingButtons />
      </div>
    </BrowserRouter>
  );
}

export default App;
